import CityLeftPartComponent from '../../components/CityComponent/CityLeftPartComponent';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(CityLeftPartComponent);
